module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAZlBMVEUAAADKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKyso+iKtBAAAAIXRSTlMA+NcjFWx3aKDIkAXMs6mGg31JOC0nGe/iv7WwmHNaVw4H50OtAAAAnklEQVQ4y82Q1xKDIBQFFUMRa2zp5fz/T2a8ZhTMxcck+3Zmd2Ag+joqrzd9CaDIgnrIMSKSgG8PmIgb1mssSMZbuFzXOjvD5/T0fC+w5tg5vonB8Jj9DTz7tzcIUdKfpQgj6P1Sq5i9Qcv5P9ggWtixQfKboDDGXDYCS6sOB5rWPRwoWvIzGNigd07AREVL+ScQlRhJWxpdSstGf8MLd38zG1/3VJwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-link-icon.png
// module id = Acex
// module chunks = 0